import router from '@/modules/accountDetails/router'

export default {
  router,
}
